module.exports = new __parcel__URL__("product4.5ff9405b.jpg").toString();